import React from "react";
import PropTypes from "prop-types";
import styles from "components/documents/no-documents.scss";
import squirrelGesturingUrl from "squirrel-gesturing.svg";

export const NoReports = ({ totalCount }) => (
  totalCount === 0 ? blankSlate() : noResults()
);

NoReports.propTypes = {
  totalCount: PropTypes.number.isRequired
};

const blankSlate = () => (
  <div className={ styles["blank-slate"] }>
    <h3>Darn! Looks like you haven&#39;t generated a report yet!</h3>
    { blankSlateText }
  </div>
);

const noResults = () => (
  <div className={ styles["no-results"] }><h3>No documents found</h3></div>
);

const blankSlateText = (
  <div>
    <img alt="squirrel gesturing" src={ squirrelGesturingUrl } />
    <div>Use the form on the left hand side to generate custom CSV or PDF reports.</div>
  </div>
);



// WEBPACK FOOTER //
// ./src/js/components/reports/no-reports.jsx